import { StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { WithColor } from '@styles/colors';
import { FontStyles } from '@styles/fonts';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { ALERT_BORDER_RADIUS } from '@components/alert/constants';
import { AlertAction, AlertActionStyle, AlertButtonProps, AlertComponentProps } from '@components/alert/types';

type GetActionFontParams = Pick<AlertComponentProps, 'boldPrimary'> & {
  font: FontStyles;
  style?: AlertActionStyle;
};

export const getActionFont = ({ font, boldPrimary, style }: GetActionFontParams): FontStyles[keyof FontStyles] => {
  switch (style) {
    case 'secondary':
      return font['Body'];
    case 'primary':
      return boldPrimary ? font['Headline Bold'] : font['Headline'];
    case 'danger':
      return font['Body'];
    default:
      return font['Body'];
  }
};

export const getActionColor = (style?: AlertActionStyle): string => {
  switch (style) {
    case 'danger':
      return 'Label/Light/Error';
    default:
      return 'Link/Light/Special';
  }
};

type GetButtonRoundingParams = Pick<AlertButtonProps, 'index' | 'isHorizontal'> & {
  actionsCount: number;
  scale: ScaleFunction;
};

export const getButtonRounding = ({ index, isHorizontal, actionsCount, scale }: GetButtonRoundingParams): Record<string, number> => {
  if (isHorizontal) {
    if (index === 0) {
      return {
        borderBottomLeftRadius: scale(ALERT_BORDER_RADIUS),
      };
    }
    if (index === actionsCount - 1) {
      return {
        borderBottomRightRadius: scale(ALERT_BORDER_RADIUS),
      };
    }
  } else {
    if (index === actionsCount - 1) {
      return {
        borderBottomLeftRadius: scale(ALERT_BORDER_RADIUS),
        borderBottomRightRadius: scale(ALERT_BORDER_RADIUS),
      };
    }
  }
  return {};
};

type GetButtonBorderParams = WithColor & Pick<AlertButtonProps, 'isHorizontal'>;

export const getButtonBorder = ({ C, isHorizontal }: GetButtonBorderParams): AlertButtonProps['btnBorder'] =>
  isHorizontal
    ? {
        borderLeftColor: C('Hairline/Light/No trans'),
        borderLeftWidth: StyleSheet.hairlineWidth,
      }
    : {
        borderTopColor: C('Hairline/Light/No trans'),
        borderTopWidth: StyleSheet.hairlineWidth,
      };

type GetAlertActionsParams = Pick<AlertComponentProps, 'actions' | 'hide'>;

export const getAlertActions = ({ actions, hide }: GetAlertActionsParams): AlertAction[] =>
  actions && actions.length
    ? actions
    : [
        {
          text: i18n.t('OK'),
          onPress: () => hide(),
          style: 'primary',
        },
      ];
